export default __webpack_public_path__ + "static/media/wireless.dd817afe.svg";